import { __extends } from "tslib";
import { IOError } from './IOError';
var EOFError = /** @class */ (function (_super) {
    __extends(EOFError, _super);
    function EOFError(message, id) {
        if (message === void 0) { message = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message, id) || this;
    }
    // Called whenever the class is initialized.
    EOFError.classInitializer = null;
    // List of static symbols to link.
    EOFError.classSymbols = null; // [];
    // List of instance symbols to link.
    EOFError.instanceSymbols = null; // [];
    return EOFError;
}(IOError));
export { EOFError };
